import { Mail, MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function Contact() {
    return (
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20" data-testid="contact-page">
            <Reveal>
                <span className="overline">Contact</span>
                <h1 className="mt-6 font-serif text-6xl md:text-7xl lg:text-8xl font-light text-brand-ink leading-[1.02] max-w-3xl">
                    Prenons
                    <span className="italic"> contact</span>.
                </h1>
            </Reveal>

            <div className="grid md:grid-cols-12 gap-12 mt-20">
                <div className="md:col-span-5 space-y-12">
                    <div>
                        <Mail size={24} strokeWidth={1.2} className="text-brand-sage mb-4" />
                        <p className="overline mb-2">Email</p>
                        <a href="mailto:contact@japet-agencement.fr" data-testid="contact-email" className="font-serif text-3xl text-brand-ink hover:text-brand-sage">
                            contact@japet-agencement.fr
                        </a>
                    </div>
                    <div>
                        <MapPin size={24} strokeWidth={1.2} className="text-brand-sage mb-4" />
                        <p className="overline mb-2">Zone d'intervention</p>
                        <p className="font-serif text-3xl text-brand-ink">Paris & Île-de-France</p>
                    </div>
                    <div>
                        <Clock size={24} strokeWidth={1.2} className="text-brand-sage mb-4" />
                        <p className="overline mb-2">Disponibilités</p>
                        <p className="font-serif text-3xl text-brand-ink">Sur rendez-vous</p>
                        <p className="text-base text-brand-sageDark mt-2">Du lundi au vendredi, 9h - 19h</p>
                    </div>
                </div>

                <div className="md:col-span-7 bg-brand-bgalt p-10 md:p-14 border border-brand-border">
                    <h2 className="font-serif text-4xl md:text-5xl text-brand-ink font-light leading-tight">
                        Vous souhaitez nous
                        <span className="italic"> confier </span>
                        un projet ?
                    </h2>
                    <p className="mt-6 text-lg text-brand-sageDark font-light leading-relaxed">
                        Pour toute demande de devis, nous vous invitons à remplir notre formulaire détaillé. Cela nous
                        permettra de mieux préparer notre premier échange et de vous proposer une réponse adaptée.
                    </p>
                    <Link
                        to="/devis"
                        data-testid="contact-cta-devis"
                        className="mt-10 inline-flex items-center gap-3 px-9 py-5 bg-brand-sage hover:bg-brand-sageDark text-brand-bg text-sm uppercase tracking-[0.22em] transition-colors"
                    >
                        Accéder au formulaire de devis
                    </Link>
                </div>
            </div>
        </div>
    );
}
